<script lang="ts">
  import type { PageKind, TemplateId } from '../store/types';
  import { TEMPLATES, templatesForKind } from '../theme/templates';

  let { defaultKind, defaultTemplate, oncreate, onclose }: {
    defaultKind: PageKind;
    defaultTemplate: TemplateId;
    oncreate: (kind: PageKind, templateId: TemplateId) => Promise<void>;
    onclose: () => void;
  } = $props();

  let kind = $state<PageKind>(defaultKind);
  let template = $state<TemplateId>(defaultTemplate);
  let creating = $state(false);

  const templates = $derived(templatesForKind(kind));
  $effect(() => { if (!templates.includes(template)) template = templates[0]!; });

  async function create() {
    if (creating) return;
    creating = true;
    try {
      await oncreate(kind, template);
    } finally {
      creating = false;
    }
  }
</script>

<div class="backdrop" onclick={onclose} role="presentation">
  <div class="modal" onclick={(e) => e.stopPropagation()} role="dialog" aria-label="New page">
    <h2>New page</h2>
    <div class="row">
      <span>Pages</span>
      <button class:active={kind === 'fixed'} onclick={() => (kind = 'fixed')}>Fixed (A4)</button>
      <button class:active={kind === 'infinite'} onclick={() => (kind = 'infinite')}>Infinite canvas</button>
    </div>
    <div class="row">
      <span>Paper</span>
      {#each templates as t}
        <button class:active={template === t} onclick={() => (template = t)}>{TEMPLATES[t].label}</button>
      {/each}
    </div>
    <div class="footer">
      <button onclick={onclose}>Cancel</button>
      <button class="primary" disabled={creating} onclick={create}>Create</button>
    </div>
  </div>
</div>

<style>
  .backdrop { position: fixed; inset: 0; background: rgba(0,0,0,0.3); display: grid; place-items: center; z-index: 50; }
  .modal { background: var(--surface); border-radius: var(--radius-modal); padding: 24px; width: min(440px, 92vw); box-shadow: var(--shadow-soft); display: flex; flex-direction: column; gap: 14px; }
  h2 { font-size: 17px; }
  .row { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; font-size: 13px; }
  .row > span { min-width: 52px; opacity: 0.7; }
  button { border: 1px solid var(--hairline); background: var(--paper); color: var(--ink-primary); border-radius: var(--radius-panel); padding: 8px 12px; min-height: 40px; cursor: pointer; }
  button.active { border-color: var(--accent); box-shadow: 0 0 0 1px var(--accent); }
  .footer { display: flex; justify-content: flex-end; gap: 8px; margin-top: 6px; }
  .primary { background: var(--accent); color: #fff; border: none; }
  .primary:disabled { opacity: 0.5; cursor: default; }
</style>
